import { generateTranslationHook } from "../utils/translation-hook-generator";

export type FooterMessages = typeof import("../../../locales/en/footer.json");

export const useFooterTranslations =
	generateTranslationHook<FooterMessages>("footer");
